import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import ProtectedRoute from "./components/ProtectedRoute";

// Pages
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import Dashboard from "./pages/Dashboard";
import AICoachPage from "./pages/AICoachPage";
import CryptoNewsPage from "./pages/CryptoNewsPage";
import CommunityPage from "./pages/CommunityPage";
import StorePage from "./pages/StorePage";
import MyPurchasesPage from "./pages/MyPurchasesPage";
import AboutPage from "./pages/AboutPage";
import TradingViewChartsPage from "./pages/TradingViewChartsPage";
import BitcoinRainbowChartPage from "./pages/BitcoinRainbowChartPage";
import GalleryPage from "./pages/GalleryPage";
import PricingPage from "./pages/PricingPage";
import ProfilePage from "./pages/ProfilePage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import FearGreedPage from "./pages/FearGreedPage";
import SubscriptionSuccessPage from "./pages/SubscriptionSuccessPage";
import AnalyticsPage from "./pages/AnalyticsPage";

const AppContent = () => {
  const location = useLocation();
  const hideNavbar = ['/', '/login', '/register', '/forgot-password', '/reset-password', '/verify-email'].includes(location.pathname);

  return (
    <div className="App min-h-screen bg-[#0A0A0A]">
      {!hideNavbar && <Navbar />}
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/community" element={<CommunityPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/store" element={<StorePage />} />
        <Route path="/my-purchases" element={
          <ProtectedRoute>
            <MyPurchasesPage />
          </ProtectedRoute>
        } />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/tradingview" element={<TradingViewChartsPage />} />
        <Route path="/rainbow-chart" element={<BitcoinRainbowChartPage />} />
        <Route path="/fear-greed" element={<FearGreedPage />} />

        {/* Protected Routes */}
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />
        <Route path="/ai-coach" element={
          <ProtectedRoute>
            <AICoachPage />
          </ProtectedRoute>
        } />
        <Route path="/crypto-news" element={
          <ProtectedRoute>
            <CryptoNewsPage />
          </ProtectedRoute>
        } />
        <Route path="/profile" element={
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        } />
        <Route path="/subscription/success" element={
          <ProtectedRoute>
            <SubscriptionSuccessPage />
          </ProtectedRoute>
        } />
        <Route path="/admin/analytics" element={
          <ProtectedRoute>
            <AnalyticsPage />
          </ProtectedRoute>
        } />
      </Routes>
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
